import { SwapSettingIcon } from './SettingIcon'
import { SwapSettingModal } from './SettingModal'
import { SlippageTolerance } from './SlippageTolerance'

export {
  SlippageTolerance,
  SwapSettingIcon,
  SwapSettingModal
}
